import {useEffect} from 'react'
import {Navigate, Outlet} from 'react-router-dom'

const PublicRoute = (props) => {
    const {login, checkAuth, checking} = props

    useEffect(() => {
        // Vérifier si l'utilisateur est déjà connecté via le cookie HttpOnly
        if (!login && checkAuth) {
            checkAuth()
        }
    }, [])

    // Si connecté, rediriger vers l'accueil
    if (login) {
        return <Navigate to={'/'} replace />
    }

    // Pendant la vérification, ne rien afficher (ou un loader)
    if (checking) {
        return null
    }

    return <Outlet />
}

export default PublicRoute
